import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import nlLocale from "@fullcalendar/core/locales/nl";
import { before } from "@splidejs/splide/src/js/utils";

document.addEventListener("DOMContentLoaded", function () {
  if (!document.getElementById("place_order")) {
    return;
  }
  const calendarEl = document.getElementById("calendar");
  const dateInput = document.getElementById("delivery-date");
  const timeInput = document.getElementById("delivery-time");

  if (calendarEl === null || dateInput === null || timeInput === null) {
    return;
  }
  var isAdminOrder = document.getElementsByClassName("admin-order").length > 0;
  jQuery(function ($) {
    $.ajax({
      url: "/wp-admin/admin-ajax.php",
      type: "POST",
      data: {
        action: "populate_delivery_fields",
      },
      success: function (response) {
        response = JSON.parse(response);
        if (response.success) {
          dateInput.value = response.date;
          timeInput.value = response.time;

          const event = new Event("change");
          dateInput.dispatchEvent(event);
        }
      },
    });
  });

  let calendar = new Calendar(calendarEl, {
    plugins: [dayGridPlugin, interactionPlugin],
    initialView: "dayGridMonth",
    locale: nlLocale,
    showNonCurrentDates: false,
    dateClick: function (info) {
      if (info.dayEl.classList.contains("disabled-day") && !isAdminOrder) {
        return;
      }
      dateInput.value = info.dateStr;

      const event = new Event("change");
      dateInput.dispatchEvent(event);
      calendar.destroy();
    },
    datesSet: function (info) {
      getAvailableDates(info);
    },
  });

  dateInput.addEventListener("click", function (e) {
    e.preventDefault();
    calendar.render();
  });

  dateInput.addEventListener("change", function (e) {
    e.preventDefault();

    jQuery(function ($) {
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "POST",
        data: {
          action: "get_available_timeslots_from_date",
          date: dateInput.value,
          isAdminOrder: isAdminOrder,
        },
        beforeSend: function () {
          const options = timeInput.querySelectorAll("option");
          options.forEach((option, index) => {
            if (index !== 0) {
              option.remove();
            }
          });
        },
        success: function (response) {
          response = JSON.parse(response);
          var timeslots = response.timeslots;

          for (let [key, value] of Object.entries(timeslots)) {
            timeInput.innerHTML += `<option value="${key}">${value}</option>`;
          }
        },
      });
    });
  });
  timeInput.addEventListener("change", function (e) {
    e.preventDefault();

    jQuery(function ($) {
      var date = dateInput.value;
      var time = timeInput.value;

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "POST",
        data: {
          action: "validate_delivery_options",
          date: date,
          time: time,
        },
      });
    });
  });

  dateInput.addEventListener("change", function (e) {
    e.preventDefault();
    jQuery(function ($) {
      var date = dateInput.value;
      var time = timeInput.value;

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "POST",
        data: {
          action: "validate_delivery_options",
          date: date,
          time: time,
        },
      });
    });
  });
  function getAvailableDates(info) {
    jQuery(function ($) {
      var startDate = new Date(calendar.view.currentStart);
      var endDate = new Date(calendar.view.currentEnd);
      endDate.setDate(endDate.getDate() - 1);

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "POST",
        data: {
          action: "get_available_dates",
          start_date: formatDateToLocalISO(startDate),
          end_date: formatDateToLocalISO(endDate),
        },
        beforeSend: function () {
          $(".fc-scroller-harness-liquid").addClass("order-loading");
        },
        success: function (response) {
          $(".fc-scroller-harness-liquid").removeClass("order-loading");
          response = JSON.parse(response);
          if (response.dates) {
            const disabledDates = response.dates;
            const cells = document.querySelectorAll(".fc-daygrid-day");
            const today = new Date();
            const minOrderDateDays = response.min_order_date_days || 0;

            // Calculate the minimum allowed date
            var minAllowedDate = new Date(today);

            if ($("#min-order-date").length > 0) {
              minAllowedDate = new Date($("#min-order-date").val());
            } else {
              minAllowedDate.setDate(
                today.getDate() + parseInt(minOrderDateDays)
              );
            }

            // Calculate the maximum allowed date (cat_order_until)
            var maxAllowedDate = null;
            if ($("#max-order-date").length > 0) {
              maxAllowedDate = new Date($("#max-order-date").val());
            }

            cells.forEach((cell) => {
              const cellDate = cell.getAttribute("data-date");
              const cellDateObj = new Date(cellDate);

              // Disable cells before the minimum allowed date
              if (cellDateObj < minAllowedDate) {
                cell.classList.add("disabled-day");
              }

              // Disable cells after the maximum allowed date
              if (maxAllowedDate && cellDateObj > maxAllowedDate) {
                cell.classList.add("disabled-day");
              }

              // Disable cells based on the disabledDates array
              if (disabledDates.includes(cellDate)) {
                cell.classList.add("disabled-day");
              }
            });
          }
        },
      });
    });
  }

  function formatDateToLocalISO(date) {
    var tzoffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
    var localISOTime = new Date(date - tzoffset).toISOString().slice(0, -1);
    return localISOTime;
  }
});
